<ng-container *ngIf="project">
  <ng-container *ngIf="project.can_vote">
    <div *ngIf="project.votes && project.votes !== 0 && project.votes !== 1" class="votes-number-mobile">
      <img loading="lazy" src="/assets/icons/north_star/{{ project.north_star }}_selected.svg" alt="{{ project.north_star }}">
      {{ 'PROJECT_PAGE.supporting0_projectpage' | translate }}
      <span>{{ project.votes }}</span>
      {{ 'PROJECT_PAGE.supporting1_projectpage' | translate }}
    </div>
    <div *ngIf="project.votes && project.votes !== 0 && project.votes === 1" class="votes-number-mobile">
      <img loading="lazy" src="/assets/icons/north_star/{{ project.north_star }}_selected.svg" alt="{{ project.north_star }}">
      {{ project.votes }} {{ 'PROJECT_PAGE.supporting2_projectpage' | translate }}
    </div>
    <div *ngIf="project.votes === 0" class="votes-number-mobile">
      <img loading="lazy" src="/assets/icons/north_star/{{ project.north_star }}_selected.svg" alt="{{ project.north_star }}">
      {{ 'PROJECT_PAGE.supporting3_projectpage' | translate }}
    </div>
  </ng-container>
  <div class="info-block">
    <div class="impact-block" *ngIf="(isLogged && !project.funded && project.can_vote) || (!isLogged && !project.funded && project.active) || (isLogged && !project.funded && project.active && !isPledge)">
      <div class="top-impact-wrapper">
        <div class="top-impact-logo">
          <img loading="lazy" src="/assets/icons/north_star/{{ project.north_star }}_selected.svg" alt="{{ project.north_star }}">
        </div>
        <div class="impact-goal" *ngIf="gaugeStatus !== 2 && !project.square_meters">
          <span>{{ project.progress }}</span> /{{ project.target_kpi }} {{ project.main_kpi_unit[currentLanguage] }}
        </div>
        <div class="impact-goal" *ngIf="gaugeStatus !== 2 && project.square_meters">
          <span>{{ project.progress * 10000 | number : '1.0-2' }}</span> /{{ project.target_kpi * 10000 | ceil }} {{ project.square_meters_unit[currentLanguage] }}
        </div>
        <div class="impact-goal" *ngIf="gaugeStatus === 2 && !project.square_meters">
          <span>{{ project.progress }}</span> /{{ project.second_target_kpi }} {{ project.main_kpi_unit[currentLanguage] }}
        </div>
        <div class="impact-goal" *ngIf="gaugeStatus === 2 && project.square_meters">
          <span>{{ project.progress * 10000 | number : '1.0-2' }}</span> /{{ project.second_target_kpi * 10000 | ceil }} {{ project.square_meters_unit[currentLanguage] }}
        </div>
      </div>
      <div class="gauge-wrapper">
        <div class="gauge-container">
          <div class="gauge">
            <div *ngIf="gaugeStatus !== 2" class="gauge-progress" [style.width]="100 * project.progress / project.target_kpi + '%'"></div>
            <div *ngIf="gaugeStatus !== 2" class="gauge-tick" [style.left]="100 * project.progress / project.target_kpi + '%'"></div>
            <div *ngIf="gaugeStatus === 2" class="gauge-progress" [style.width]="100 * project.progress / project.second_target_kpi + '%'"></div>
            <div *ngIf="gaugeStatus === 2" class="first-gauge-tick"
              [style.left]="100 * project.target_kpi / project.second_target_kpi + '%'"
              [left]="true"
              [padding]="5"
              [tooltipText]="getTooltipText()"
              [top]="false"
              [tooltipClass]="'ns-tooltip-container-1 ns-tooltip-max-content'"
              nsTooltip>
            </div>
            <div *ngIf="gaugeStatus === 2" class="gauge-tick" [style.left]="100 * project.progress / project.second_target_kpi + '%'"></div>
          </div>
        </div>
        <div *ngIf="gaugeStatus !== 2" class="gauge-percentage">{{ roundPercentage(100 * project.progress / project.target_kpi) + '%' }}</div>
        <div *ngIf="gaugeStatus === 2" class="gauge-percentage">{{ roundPercentage(100 * project.progress / project.second_target_kpi) + '%' }}</div>
      </div>
      <div class="cost">
        {{ "PROJECT_PAGE.cost_projectpage" | translate }} {{ project.secundary_kpi_unit[currentLanguage] }}: <span>{{ project.secundary_kpi }}€</span>
      </div>
    </div>

    <div class="funded-block" *ngIf="project.funded">
      <div class="funded-image">
        <img src="/assets/icons/funded.svg" alt="funded">
      </div>
      <div class="funded-title">{{ 'PROJECT_PAGE.funded_projectpage' | translate }}</div>
      <div *ngIf="!project.second_target_kpi" class="funded-text">{{ project.target_kpi }} {{ project.main_kpi_unit[currentLanguage] }}</div>
      <div *ngIf="project.second_target_kpi" class="funded-text">{{ project.second_target_kpi }} {{ project.main_kpi_unit[currentLanguage] }}</div>
    </div>

    <div class="unavailable-block" *ngIf="(isLogged && isPledge && !project.can_vote && !project.funded) || (!isLogged && !project.funded && !project.active) || (isLogged && !isPledge && !project.active && !project.funded)">
      {{ 'PROJECT_PAGE.unavailable_projectpage' | translate }}
    </div>

    <div class="about-button"
      (click)="openAboutDialog('info', project.organization_name, project.organization_logo, project.organization_additional_data, project.organization_website, project.organization_description, project.standards)">
      <img loading="lazy" src="assets/icons/info.svg" alt="info">{{ 'PROJECT_PAGE.about_projectpage' | translate }} {{ project.organization_name }}
    </div>

    <div class="standards-button"
      (click)="openAboutDialog('standards', project.organization_name, project.organization_logo, project.organization_additional_data, project.organization_website, project.organization_description, project.standards)"
      *ngIf="project.standards.length">
      <img loading="lazy" src="assets/icons/star.svg" alt="standards">{{ 'PROJECT_PAGE.standards1_projectpage' | translate }}
    </div>

    <div *ngIf="project.main_video" class="main-video-wrapper">
      <iframe
          *ngIf="isYoutubeVideo(project.main_video)"
          [src]="project.main_video | safeurl"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
          height="auto"
      ></iframe>
      <div *ngIf="!isYoutubeVideo(project.main_video)" class="video">
        <video #video (click)="pauseVideo(video)" [controls]="!video.paused">
          <source [src]="project.main_video">
        </video>
        <button (click)="playVideo(video)" *ngIf="isPaused(video)" class="play-button">
          <i class="fa-solid fa-play"></i>
        </button>
      </div>
    </div>

    <div *ngIf="project.description_title" class="description-title">{{ project.description_title[currentLanguage] }}</div>
    <ng-container *ngIf="screenWidth > 1100">
      <div [innerHTML]="project.description[currentLanguage]" class="description"></div>
    </ng-container>
    <ng-container *ngIf="screenWidth <= 1100">
      <div *ngIf="readMoreClicked" [innerHTML]="project.description[currentLanguage]" class="description"></div>
      <div *ngIf="!readMoreClicked" [innerHTML]="project.description[currentLanguage].slice(0, 400) + '...'" class="description"></div>
      <div *ngIf="project.description[currentLanguage].length > 400" class="read-more-less">
        <div (click)="toggleReadMore()" *ngIf="!readMoreClicked" class="read-more">{{ "NEWS_TAB.read_more_newstab" | translate }}</div>
        <div (click)="toggleReadMore()" *ngIf="readMoreClicked" class="read-more">{{ "NEWS_TAB.read_less_newstab" | translate }}</div>
      </div>
    </ng-container>
    <div *ngIf="project.quote_1" class="quote">"{{ project.quote_1[currentLanguage] }}"</div>
    <div *ngIf="project.quote_1_author" class="quote-author">— {{ project.quote_1_author[currentLanguage] }}</div>
    <div *ngIf="project.quote_2" class="quote">"{{ project.quote_2[currentLanguage] }}"</div>
    <div *ngIf="project.quote_2_author" class="quote-author">— {{ project.quote_2_author[currentLanguage] }}</div>

    <div *ngIf="project.testimony" class="testimony">{{ project.testimony[currentLanguage] }}</div>

    <div *ngIf="project.figures.length >= 1" class="figures">
      <div class="figures-title">{{ project.organization_name }} {{ "PROJECT_PAGE.figures_projectpage" | translate }}</div>
      <div class="figures-wrapper">
        <div *ngFor="let project_figure of project.figures" class="figure-block">
          <div class="figure-figure">{{ project_figure.figure[currentLanguage] }}</div>
          <div [innerHTML]="project_figure.content[currentLanguage]" class="figure-content"></div>
        </div>
      </div>
    </div>

    <div *ngIf="project.intention" class="intention">
      <div *ngIf="project.can_vote" class="intention-title">{{ "PROJECT_PAGE.intention1_projectpage" | translate }}</div>
      <div *ngIf="!project.can_vote" class="intention-title">{{ "PROJECT_PAGE.intention2_projectpage" | translate }}</div>
      <div class="intention-content">{{ project.intention[currentLanguage] }}</div>
    </div>

    <div *ngIf="project.reasons.length >= 1" class="reasons">
      <div class="reasons-title">{{ "PROJECT_PAGE.why_vetted1_projectpage" | translate }} {{ project.vetted_by }} {{ "PROJECT_PAGE.why_vetted2_projectpage" | translate }}</div>
      <div class="reasons-wrapper">
        <div *ngFor="let reason of project.reasons" class="reason-block">
          <img [src]="reason.logo" alt="reason-logo" class="reason-logo">
          <div class="reason-title">{{ reason.name[currentLanguage] }}</div>
          <div [innerHTML]="reason.content[currentLanguage]" class="reason-content"></div>
        </div>
      </div>
    </div>

    <div class="sdg-title">{{ "PROJECT_PAGE.sdg_title_projectpage" | translate }}</div>
    <div class="sdg-mobile">
      <div class="sdg-card" *ngFor="let sdg of project.sdg">
        <img loading="lazy" [src]="sdg.image" [alt]="sdg.name">
      </div>
    </div>

    <div class="location">
      <div class="location-title">{{ "PROJECT_PAGE.where_projectpage" | translate }}</div>
      <div class="location-details" *ngIf="project.continent !== 'worldwide'">
        {{ 'COUNTRIES.' + project.country | translate }}
        , {{ 'PREFERENCES_POPUP_2.' + project.continent + '_preferencespopup2' | translate }}
      </div>
      <div class="location-details" *ngIf="project.continent === 'worldwide'">
        {{ 'PREFERENCES_POPUP_2.' + project.continent + '_preferencespopup2' | translate }}
      </div>
      <div class="geomap-container">
        <app-geomap *ngIf="project.continent !== 'worldwide'"
                    [latitude]="project.latitude"
                    [longitude]="project.longitude">
        </app-geomap>
      </div>
    </div>

    <div *ngIf="project.media.length >= 1" class="more-media-title">More media</div>
    <div *ngIf="project.media.length >= 1" class="right-side-3">
      <div #carousel class="carousel">
        <div #slider class="slider slide">
          <section *ngFor="let media of project.media; let i = index" class="slide">
            <!-- Youtube video slide type -->
            <iframe class="slide"
                    *ngIf="isYoutubeVideo(project.media[currentIndex])"
                    [src]="project.media[currentIndex] | safeurl"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                    height="auto"
            ></iframe>
            <!-- Custom video slide type -->
            <div *ngIf="!isYoutubeVideo(project.media[currentIndex]) && !isImage(project.media[currentIndex])" class="video slide">
              <video class="slide" #video (click)="pauseVideo(video)"
                     [controls]="!video.paused" id="video{{ i }}">
                <source [src]="project.media[currentIndex]">
              </video>
              <button (click)="playVideo(video)" *ngIf="isPaused(video)" class="play-button slide">
                <i class="fa-solid fa-play"></i>
              </button>
            </div>
            <!-- Image slide type -->
            <div *ngIf="isImage(project.media[currentIndex])" [ngStyle]="{'background': 'center / cover no-repeat url(' + project.media[currentIndex] + ')'}" class="img slide">
            </div>
          </section>
        </div>
      </div>
      <div class="controls slide">
        <div class="slider-ticks slide">
          <div *ngFor="let media of project.media; let i = index" [ngClass]="{'active': currentIndex === i}" class="slider-tick"></div>
        </div>
        <div (click)="prev(project.media.length)" class="prev slide">
          <i class="fa-solid fa-angle-left"></i>
        </div>
        <div (click)="next(project.media.length)" class="next slide">
          <i class="fa-solid fa-angle-right"></i>
        </div>
      </div>
    </div>
  </div>
</ng-container>